import { styled as t } from "styled-components";
const i = t.div`
  display: inline-block;
  text-align: center;
  width: auto;
`, l = t.small`
  display: flex;
  flex-direction: column;
`;
export {
  l as OffText,
  i as StampContainer
};
